import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import SocialLinks from './components/SocialLinks'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
    <SocialLinks />
  </React.StrictMode>
)
